import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import { Card, CardHeader, Collapse } from 'reactstrap';

const column1 = [
  {
    Header: 'Company Name',
    accessor: 'company',
  },

  {
    Header: 'Street Address',
    accessor: 'address',
  },
  {
    Header: 'City',
    accessor: 'city',
  },
  {
    Header: 'State',
    accessor: 'state',
  },
  {
    Header: 'Zip Code',
    accessor: 'zip',
  },
  {
    Header: 'Country',
    accessor: 'country',
  },
];

const column2 = [
  {
    Header: 'Company Website',
    accessor: 'url',
  },
  {
    Header: 'Point of Contact',
    accessor: 'poc',
  },
  {
    Header: 'Email Address',
    accessor: 'email',
  },
  {
    Header: 'Phone Number',
    accessor: 'phone',
  },
  {
    Header: 'ICON Member',
    accessor: 'memberStatus',
  },
  {
    Header: 'CAGE',
    accessor: 'cage',
  },
];
const column3 = [
  {
    Header: 'Industry Type',
    accessor: 'indType',
  },
  {
    Header: 'Industry Affiliation',
    accessor: 'indAff',
  },
];
const Header = data => {
  const [toggleQuestion, setToggequestion] = useState(1);

  return (
    <div className="nf-u-details__grid">
      <Card className="nf-solicitation-detail__card">
        <CardHeader
          className="nf-solicitation-detail__card-header"
          onClick={() => setToggequestion(!toggleQuestion)}
        >
          Supplier Details {toggleQuestion ? <UpOutlined /> : <DownOutlined />}
        </CardHeader>
        <Collapse isOpen={toggleQuestion}>
          <ReactTable
            data={data.block}
            columns={column1}
            defaultPageSize={data.block ? data.block.length : 1}
            style={{ textAlign: 'left' }}
            showPagination={false}
          />

          <div style={{ background: 'whitesmoke' }}>
            <br />
          </div>
          <ReactTable
            data={data.block}
            columns={column2}
            defaultPageSize={data.block.length > 0 ? data.block.length : 3}
            style={{ textAlign: 'left' }}
            showPagination={false}
          />
          <div style={{ background: 'whitesmoke' }}>
            <br />
          </div>
          <ReactTable
            data={data.block}
            columns={column3}
            defaultPageSize={data.block.length > 0 ? data.block.length : 3}
            style={{ textAlign: 'left' }}
            showPagination={false}
          />
        </Collapse>
      </Card>
      {/* <Table dataSource={drawings} columns={columns} /> */}
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/universalDetails/CageDetailsTables/Foo.jsx